/* Vierro best sellers: endless strip. Tabs follow the product at the left edge; progress bar; bounce hint.
   The loop works by moving the existing cards around (no duplicate cards, forms or images), only while scrolling is settled. */
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function ease(x) { return x < .5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2; }

  function init(root) {
    if (root.__viUs) return;
    var track = root.querySelector('[data-vi-track]');
    var N = track.children.length;
    var rest = root.querySelector('template[data-vi-rest]'), TOTAL = +root.dataset.total || N, expanded = !rest;
    if (N < 3) return;
    root.__viUs = true;
    var tabsEl = root.querySelector('.vi-us__tabs'), tabs = [].slice.call(root.querySelectorAll('[data-vi-tab]'));
    var bar = root.querySelector('[data-vi-bar]'), notchWrap = root.querySelector('[data-vi-notches]');
    var B = Math.max(3, Math.floor(N / 3)), step = 0, perView = 2, touched = false, nudging = false, down = false, settleT = 0, ticking = false, lastCat = -1, started = false, epoch = 0;
    var wrapRoot = root.closest('.otsb__root') || document;
    var viewAll = [].slice.call(wrapRoot.querySelectorAll('a.nav-link')).filter(function (a) { return /view all/i.test(a.textContent); })[0];

    /* remember each card's original position, and where each category starts (read from the tabs, so it is right before the rest has loaded) */
    var firstOf = {};
    [].forEach.call(track.children, function (el, i) { el.dataset.i = i; });
    tabs.forEach(function (t) { firstOf[+t.dataset.viTab] = +t.dataset.start || 0; });
    Object.keys(firstOf).forEach(function (c) { if (+c > 0) { var b = document.createElement('b'); b.style.left = (firstOf[c] / TOTAL * 100) + '%'; notchWrap.appendChild(b); } });

    function measure() {
      var s = track.children;
      if (s.length < 2) return false;
      step = s[1].offsetLeft - s[0].offsetLeft;
      perView = Math.max(1, Math.floor(track.clientWidth / step + 0.2));
      return step > 0;
    }
    function jump(l) {
      track.classList.add('is-free'); track.scrollLeft = l;
      setTimeout(function () { track.classList.remove('is-free'); }, 60);
    }
    function mutate(fn) { if (window.Alpine && Alpine.mutateDom) Alpine.mutateDom(fn); else fn(); }
    function leftIdx() { return step ? Math.round(track.scrollLeft / step) : 0; }
    function slideAt(i) { return track.children[Math.max(0, Math.min(N - 1, i))]; }
    function canon(i) { return +slideAt(i).dataset.i; }
    function norm(i) { return ((i % N) + N) % N; }

    /* moving k cards from one end to the other keeps the same card in view, so nothing visibly changes */
    function toFront(k) {
      if (k <= 0) return; var l = track.scrollLeft; epoch++;
      mutate(function () { for (var i = 0; i < k; i++) track.insertBefore(track.lastElementChild, track.firstElementChild); });
      jump(l + k * step);
    }
    function toEnd(k) {
      if (k <= 0) return; var l = track.scrollLeft; epoch++;
      mutate(function () { for (var i = 0; i < k; i++) track.appendChild(track.firstElementChild); });
      jump(l - k * step);
    }
    function recenter(d) {                      /* put the middle of the coming journey in the middle of the strip */
      var mid = Math.floor(N / 2), k = leftIdx() + Math.round((d || 0) / 2) - mid;
      if (k > 0) toEnd(k); else if (k < 0) toFront(-k);
    }
    /* bring in the other categories (they wait in an inert <template> until the shopper first scrolls, taps or moves) */
    function expand() {
      if (expanded) return; expanded = true;
      var frag = document.importNode(rest.content, true), idx = N;
      [].forEach.call(frag.children, function (el) { el.dataset.i = idx++; });
      mutate(function () { track.appendChild(frag); });
      rest.remove(); N = track.children.length; B = Math.max(3, Math.floor(N / 3));
      measure(); if (started) toFront(B);
      update();
    }
    function settle() {
      if (!step || down || !expanded) return;
      var i = leftIdx();
      if (i < B) toFront(B); else if (i > N - B - perView) toEnd(B);
    }

    function setActive(c) {
      if (c === lastCat) return; lastCat = c;
      tabs.forEach(function (t, i) { var on = i === c; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      var t = tabs[c];
      if (t && tabsEl) { tabsEl.scrollTo({ left: t.offsetLeft - (tabsEl.clientWidth - t.clientWidth) / 2, behavior: reduce ? 'auto' : 'smooth' }); if (viewAll && t.dataset.url) viewAll.setAttribute('href', t.dataset.url); }
    }
    function update() {
      ticking = false; if (!step) return;
      var s = slideAt(leftIdx());
      setActive(+s.dataset.cat);
      var f = +s.dataset.i; bar.style.width = Math.min(100, (f + perView) / TOTAL * 100) + '%';
    }
    track.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; var ran = false, run = function () { if (ran) return; ran = true; update(); }; requestAnimationFrame(run); setTimeout(run, 60); }
      clearTimeout(settleT); settleT = setTimeout(settle, 140);
      var i = leftIdx(); if (expanded && (i <= 0 || i >= N - perView - 1)) settle();   /* flung right to the edge: re-centre straight away */
    }, { passive: true });

    function smoothBy(d) { track.scrollBy({ left: d, behavior: reduce ? 'auto' : 'smooth' }); }
    function interacted() { touched = true; }
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) { track.addEventListener(ev, interacted, { passive: true, once: true }); });
    track.addEventListener('pointerdown', function () { down = true; }, { passive: true });
    ['pointerup', 'pointercancel', 'touchend'].forEach(function (ev) { window.addEventListener(ev, function () { down = false; clearTimeout(settleT); settleT = setTimeout(settle, 160); }, { passive: true }); });

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        interacted(); expand();
        var c = +t.dataset.viTab, first = firstOf[c]; if (first == null) return;
        var d = first - canon(leftIdx());
        if (d > N / 2) d -= N; if (d <= -N / 2) d += N;
        recenter(d);
        smoothBy(d * step);
      });
    });
    var prev = root.querySelector('[data-vi-prev]'), next = root.querySelector('[data-vi-next]');
    if (prev) prev.addEventListener('click', function () { interacted(); expand(); if (leftIdx() < perView + 2) toFront(B); smoothBy(-perView * step); });
    if (next) next.addEventListener('click', function () { interacted(); expand(); if (leftIdx() > N - perView - 3) toEnd(B); smoothBy(perView * step); });

    /* bounce hint: the cards nudge sideways and spring back so people know there is more */
    function nudge() {
      if (reduce || touched || nudging || !step || !matchMedia('(max-width: 989px)').matches) return; nudging = true;
      var ep = epoch, start = track.scrollLeft, dx = Math.min(64, step * .42), t0 = performance.now(), dur = 950;
      track.classList.add('is-free');
      (function frame(now) {
        if (epoch !== ep) { track.classList.remove('is-free'); nudging = false; return; }   /* cards were re-ordered meanwhile: leave the position alone */
        var t = Math.min(1, (now - t0) / dur), e;
        if (t < .4) e = ease(t / .4) * dx; else if (t < .72) e = dx * (1 - 1.18 * ease((t - .4) / .32)); else e = -.18 * dx * (1 - ease((t - .72) / .28));
        track.scrollLeft = start + e;
        if (t < 1 && !touched) requestAnimationFrame(frame);
        else { if (!touched) track.scrollLeft = start; track.classList.remove('is-free'); nudging = false; }
      })(t0);
    }
    function scheduleHints() { setTimeout(nudge, 2000); setTimeout(nudge, 6500); setTimeout(nudge, 15000); }

    if (rest) {
      var armed = false, arm = function (ev) {
        if (ev && ev.type === 'scroll' && ev.target !== document) return;       /* the strip's own scrolling does not count */
        if (armed) return; armed = true;
        ['touchstart', 'pointerdown', 'wheel', 'keydown', 'mousemove', 'scroll'].forEach(function (ev) { window.removeEventListener(ev, arm, true); });
        (window.requestIdleCallback || function (f) { setTimeout(f, 250); })(expand, { timeout: 1500 });
      };
      ['touchstart', 'pointerdown', 'wheel', 'keydown', 'mousemove', 'scroll'].forEach(function (ev) { window.addEventListener(ev, arm, { passive: true, capture: true }); });
    }
    function start() {
      if (started) return; started = true;
      if (measure() && expanded) { toFront(B); }   /* room to scroll backwards from the first card */
      update(); scheduleHints();
    }
    function near() { var r = root.getBoundingClientRect(); return r.top < window.innerHeight + 200 && r.bottom > -200; }
    function check() { if (!started && near()) { start(); window.removeEventListener('scroll', check); clearInterval(poll); } }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { start(); io.disconnect(); } }, { rootMargin: '200px', threshold: .35 });
      io.observe(root);
    }
    window.addEventListener('scroll', check, { passive: true });
    var poll = setInterval(check, 800); setTimeout(check, 300);
    var rw = window.innerWidth, rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt); rt = setTimeout(function () {
        if (Math.abs(window.innerWidth - rw) < 30 || !started) return; rw = window.innerWidth;
        var i = leftIdx(); measure(); jump(i * step);
      }, 200);
    });
    window.addEventListener('load', function () { if (started) { var i = leftIdx(); measure(); jump(i * step); } update(); });
  }
  ready(function () { [].forEach.call(document.querySelectorAll('[data-vi-us]'), init); });
  document.addEventListener('shopify:section:load', function () { [].forEach.call(document.querySelectorAll('[data-vi-us]'), init); });
})();
